import { useApolloClient } from "@apollo/client";
import { getDataOrNull } from "@msys/common";
import { useSnackbar } from "notistack";
import React from "react";
import { useGetQuoteDataLazyQuery } from "./useGetQuoteData.generated.js";

export type QuoteDataCalculationType = "agreed" | "proposed";

export function useGetQuoteData({
  projectId,
  docId,
}: {
  projectId: string;
  docId: string;
}) {
  const [loadingQuoteData, setLoadingQuoteData] = React.useState<null | string>(
    null
  );
  const { enqueueSnackbar } = useSnackbar();

  const client = useApolloClient();
  const [fetch] = useGetQuoteDataLazyQuery({ client });

  const handleFetch = async (calculationType: QuoteDataCalculationType) => {
    if (loadingQuoteData) return null;

    const key = `inspect-${calculationType}`;
    setLoadingQuoteData(key);

    try {
      const { data } = await fetch({
        variables: {
          projectId,
          quoteId: docId,
          calculationType,
        },
      });
      const quoteData = getDataOrNull(data?.quoteGetGeneratorData)?.quoteData;
      if (quoteData === undefined || quoteData === null) {
        throw new Error("Failed to fetch quote data");
      }
      return quoteData;
    } catch (error) {
      if (error instanceof Error)
        enqueueSnackbar(error.message, { variant: "error" });
      return null;
    } finally {
      setLoadingQuoteData(null);
    }
  };

  return { handleFetch, loadingQuoteData };
}
